import {
    createEntityAdapter,
} from '@reduxjs/toolkit';
import { oauth } from '../utils';
import {  getGeneralSlice } from './helpers';

/*
client_rate_label: "aa"
commission_client_rate_id: "f23740f4-7c81-4204-a99d-c1dc1a51a541"
company_id: "60d613ea-c3db-4265-9a46-442553c8619a"
multiplier: "1.00"
*/
const adapter = createEntityAdapter({
    selectId: (object) => object.commission_client_rate_id,
    sortComparer: (a, b) => (a.client_rate_label + String(a.multiplier)).localeCompare(b.client_rate_label + String(b.multiplier))
});

/**
 * The slice/reducers
 */
const slice = getGeneralSlice('commissionClientRates', adapter);

export const {
    added,
    deleted,
    loading,
    loaded,
    received,
    updated
} = slice.actions;

const baseUrl = 'commission-client-rate';

/**
 * The actions (thunk)
 */
export const getAll = () => async (dispatch, getState) => {
    dispatch(loading());
    const res = await oauth('GET', baseUrl,  {});
    dispatch(received(res.json.commission_client_rates));
    return res.json;
};

export const addItem = (data) => async (dispatch, getState) => {
    dispatch(loading());
    const res = await oauth('POST', baseUrl, data);
    dispatch(added(Object.assign(res.json.commission_client_rate, {new: true})));
    dispatch(loaded());
    return res.json.commission_client_rate;
};

export const updateItem = (data) => async (dispatch, getState) => {
    console.log('Update', data);
    dispatch(loading());
    const res = await oauth('PUT', baseUrl + '/' + data.commission_client_rate_id, data);
    dispatch(updated({ id: data.commission_client_rate_id, changes: data }));
    dispatch(loaded());
    return res.json.commission_client_rate;
};

export const deleteItem = (data) => async (dispatch, getState) => {
    console.log('delete', data);
    dispatch(loading());
    try {
        await oauth('DELETE', baseUrl + '/' + data.commission_client_rate_id, {});
    } catch (err) {
        console.log('Failed to delete');
        return false;
    }
    console.log('deleted', data);
    dispatch(deleted(data.commission_client_rate_id));
    dispatch(loaded());
    return true;
};

/**
 * The selectors
 */
export const selectors = adapter.getSelectors();

export default slice.reducer;
